import { Injectable } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { BehaviorSubject } from 'rxjs';

/**
 * Wrapper sobre `NgxSpinnerService` — CONFIRMADO no app real (24/08/2026,
 * tenant conectaplan) que o overlay GLOBAL de loading é a biblioteca
 * `ngx-spinner` (ver core/components/loader), não um estado próprio via
 * BehaviorSubject.
 *
 * Mantemos também um `loading$` local (BehaviorSubject) pelo mesmo motivo de
 * sempre: componentes como `app-loading` (spinner pequeno/inline dentro do
 * card de login, ver core/components/loading) precisam de um Observable
 * síncrono para o `| async` no template — hoje os dois indicadores acendem
 * juntos, o que é uma simplificação aceitável para o esqueleto.
 */
@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  private pendingRequests = 0;
  private readonly loadingSubject = new BehaviorSubject<boolean>(false);
  readonly loading$ = this.loadingSubject.asObservable();

  constructor(private ngxSpinner: NgxSpinnerService) {}

  show(): void {
    this.pendingRequests++;
    this.ngxSpinner.show();
    this.loadingSubject.next(true);
  }

  hide(): void {
    this.pendingRequests = Math.max(0, this.pendingRequests - 1);
    if (this.pendingRequests === 0) {
      this.ngxSpinner.hide();
      this.loadingSubject.next(false);
    }
  }
}
